module.exports = __webpack_public_path__ + "img/seguros_el_sol.1e5c0778.png";